import spritemap from "@milestone-sys/web-design-system/msds-spritemap.svg"
import "./row-action.scss"

export const AddNoteAction = ({    
    row,    
    addClickHandler, 
}) => {
    return (
        <button id={"xsd__e2e-table-actions-add-camera-name-row-" + row.index} className="row-action" type="button" onClick={() => addClickHandler(row.index)} title="Add camera name">
            <svg className="msds-icon">
                <use href={`${spritemap}#chat`} />
            </svg>
        </button>
    )
}

